const MyConfig = {
  AWS_REGION: 'us-west-2', // ★環境ごとに変更
  AWS_USER_POOL_ID: 'us-west-2_3O33YFkzi', // ★環境ごとに変更
  AWS_CLIENT_ID: '7riuun1hjlqovilfatgkjqta2e', // ★環境ごとに変更
  AWS_IDENTIRY_POOL_ID: 'us-west-2:ac172085-48f6-4660-8618-7ff10434e9d7', // ★環境ごとに変更
  AWS_S3_BUCKET_NAME: 'j08-hoge-imagedata', // ★環境ごとに変更(接頭辞の部分のみ)
  AWS_S3_BUCKET_DIR: 'image-store/',
  API_BASE_URL: 'https://mo88s660r2.execute-api.us-west-2.amazonaws.com/prod', // ★環境ごとに変更
  API_MAINDATA_PATH: 'major',
  API_TAGDATA_PATH: 'tag',
  API_TIMEOUT: 8000,
  MSG_TIMEOUT: 8000,
  LOG_LEVEL: 1, // 0:NONE, 1:DEBUG
  LOG_TYPE_I: 'color:#555555; font-weight:semibold;',
  LOG_TYPE_E: 'color:#880000; font-weight:semibold;'
}

export { MyConfig }
